var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPic12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.02 74.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#baa1de;}.cls-2{fill:#f5c1e7;}.cls-3{fill:none;stroke:#343a40;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-4{fill:#ffed4a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9,20.83S-1.81,38.36,3.83,47.06,24.29,30.37,23.35,21.2,14.41,13.2,9,20.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.62,27.67S13.75,55,22.55,68.6s31.9-26,30.44-40.34S39,15.78,30.62,27.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.8,17.94S27.12-9,5.45,5.06,47,56,69.86,53.66,89.79,31.4,70.8,17.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M56.1,46.41S45.29,64,50.93,72.65,71.38,56,70.44,46.79,61.51,38.79,56.1,46.41Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic12);
export default __webpack_public_path__ + "static/media/Pic12.9faf5e4f651081d6c796251831170d0b.svg";
export { ForwardRef as ReactComponent };